import { FlagOverridePlugin, EventInterceptionPlugin } from '@launchdarkly/toolbar/plugins';

// Plugin singletons shared by the LD client and the dev-toolbar hook.
// Both must reference the SAME instance — separate constructions desync overrides.
// `plugins` is marked experimental on LDOptions; recheck on launchdarkly-react-client-sdk upgrades.
export const flagOverridePlugin = new FlagOverridePlugin();
export const eventInterceptionPlugin = new EventInterceptionPlugin();
